<ng-container *transloco="let convert;">
<trap-focus
  [enableFocusTrap]="true"
  [enableArrowKeys]="true"
>
  <app-modal
    [modalId]="modalId"
    class="modal--remove-mobile-phone"
  >
    <ng-container>

      <header
        class="modal__header mb-2"
      >
        <h1
          class="modal__title text-bold"
          id="remove-mobile-phone-modal-title"
          tabindex="-1"
        >
          {{convert('profileManagement.removeMobilePhoneModal.title')}}
        </h1>
      </header>

      <div class="modal__subheader">
        <p>
          {{convert('profileManagement.removeMobilePhoneModal.subHeader')}}
        </p>
      </div>

      <div class="modal__content">
        <div class="modal__body">
          <div
            class="modal__actions"
          >
            <ng-container>
              <button
                class="btn btn-danger me-md-2 mb-3 mb-md-0 me-2"
                (click)="remove()"
                data-track-elem="button"
                data-track-name="Remove"
              >
                {{convert('profileManagement.removeMobilePhoneModal.btnRemove')}}
              </button>
              <button
                class="btn btn-link cancel-btn me-md-2 mb-3 mb-md-0"
                (click)="cancel()"
                data-track-elem="button"
                data-track-name="Cancel"
              >
                {{convert('common.btnCancel')}}
              </button>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="modal-close-container">
        <button
          id="bm_close_x_button"
          class="modal__close"
          [attr.aria-label]="convert('common.modalClose')"
          (click)="close()"
          data-track-elem="icon"
          data-track-name="close"
          data-track-trigger="close"
        >
          <i
            class="allycon-glyph-close text-primary"
            aria-hidden="true"
          ></i>
        </button>
      </div>
    </ng-container>

  </app-modal>
</trap-focus>
</ng-container>
